<h2 matDialogTitle>Achtung</h2>

<mat-dialog-content>
  <mat-divider />

  <div style="margin-top: 20px">
    <mng-warning-container withCard="false" type="error">
      <div>Diese {{ data.actionType }} kann <b>NICHT</b> mehr online durchgeführt werden.</div>
    </mng-warning-container>

    <div style="margin-top: 20px">
      Sie können jedoch die ego4you Kids & Teens Informationsstelle der Merkur Lifestyle kontaktieren:
      <br />

      <mng-mgs-kids-buchung-ml-info />
    </div>
  </div>
  <mat-divider />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" mat-dialog-close>OK</button>
</mat-dialog-actions>
